import Reveal from './Reveal';
import { archiveItems } from '@/mocks/home';

export default function ArchiveStrip() {
  return (
    <section className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-8 md:py-16">
        <Reveal>
          <div className="flex flex-col gap-6 lg:flex-row lg:items-start lg:gap-12">
            <div className="lg:w-64 lg:shrink-0">
              <span className="font-label text-xs font-medium tracking-[0.25em] text-accent-600">
                ARCHIVE
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950">
                往期预告存档
              </h2>
              <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
                每一期都留档，被证伪的条目也不会消失。
              </p>
            </div>

            <div className="grid flex-1 grid-cols-1 gap-x-8 sm:grid-cols-2">
              {archiveItems.map((item) => (
                <div
                  key={item.id}
                  className="flex items-baseline gap-4 border-b border-background-200/70 py-5"
                >
                  <span className="shrink-0 font-heading text-sm font-bold text-foreground-400">
                    {item.issue}
                  </span>
                  <div className="min-w-0 flex-1">
                    <h3 className="font-heading text-base leading-snug text-foreground-900">
                      {item.title}
                    </h3>
                    <span className="mt-1 block font-label text-xs text-foreground-500">
                      {item.date}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}